import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Table, Icon, Modal, notification } from "antd";
import DrawerDoc from "./Drawer/DrawerDoc";
import ModalViewer from "../../../shared/components/Modals/ModalViewer";
import { GlobalContext } from "../../../app/providers/GlobalState";
import axios from "axios";
import moment from "moment";
import DrawerTabela from "./Drawer/DrawerTabela";
import DrawerPesquisar from "./Drawer/DrawerPesquisar";
import DrawerHTML from "./Drawer/DrawerHTML";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Tabela = ({ carregarAnosDocumentos, match, search, activated, setActivated }) => {
    const globalContext = useContext(GlobalContext);
    const [documentoId, setDocumentoId] = useState(0);
    const [documentos, setDocumentos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [visible, setVisible] = useState(false);
    const [docs, setDocs] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [estado, setEstado] = useState({
        documentoId: 0,
        nome: "",
        tipo: "UPLOAD",
        fileList: [],
        ficheiros: [],
        ficheiro: "",
        link: "",
        texto: "",
        visibleHTML: false,
        tipo_partilha: "PESSOAL",
        todos: false,
        participantes: [],
        visible: false,
        iconLoading: false,
        visibleDrawerPesquisar: false,
        visibleParticipantes: false,
        carregarLista: false
    });
    const documentoIdAnterior = useRef(null);
    const [documento, setDocumento] = useState();

    const extensions = [
        ".bmp",
        ".csv",
        ".odt",
        ".doc",
        ".docx",
        ".gif",
        ".htm",
        ".html",
        ".jpg",
        ".jpeg",
        ".pdf",
        ".png",
        ".ppt",
        ".pptx",
        ".tiff",
        ".txt",
        ".xls",
        ".xlsx"
    ];

    const cols = [
        {
            title: "Data",
            dataIndex: "data"
        },
        {
            title: "Criado por",
            dataIndex: "criado"
        },
        {
            title: "Turma",
            dataIndex: "curso"
        },
        {
            title: "Disciplina",
            dataIndex: "disciplina"
        },
        {
            title: "Documento",
            dataIndex: "documento"
        },
        {
            title: "",
            dataIndex: "opcoes",
            width: 10
        }
    ];

    const excluir = documentoId => {
        confirm({
            title: "Pretende excluir este ficheiro?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/documentos/excluir",
                    params: {
                        documentoId
                    }
                })
                    .then(response => {
                        openNotificationWithIcon("success", "Sucesso", "Ficheiro excluido!");

                        atualizar();
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível excluir o ficheiro!");
                    });
            }
        });
    };

    const carregarDetalhe = documentoId => {
        axios({
            method: "get",
            url: "/api/curso-fichs/carregar-detalhe",
            params: {
                documentoId
            }
        })
            .then(response => {
                if (response.data.tipo === "UPLOAD") {
                    setEstado({
                        documentoId: documentoId,
                        nome: response.data.nome.replace("." + response.data.nome.split(".").pop(), ""),
                        tipo: response.data.tipo,
                        tipo_partilha: response.data.tipo_partilha,
                        todos: response.data.todos,
                        participantes: response.data.participantes,
                        visible: true,
                        fileList: [],
                        ficheiros: [response.data.nome],
                        ficheiro: response.data.ficheiro,
                        link: "",
                        texto: "",
                        visibleDrawerPesquisar: false,
                        visibleHTML: false
                    });
                } else if (response.data.tipo === "LINK") {
                    setEstado({
                        documentoId: documentoId,
                        nome: response.data.nome.replace("." + response.data.nome.split(".").pop(), ""),
                        tipo: response.data.tipo,
                        tipo_partilha: response.data.tipo_partilha,
                        todos: response.data.todos,
                        participantes: response.data.participantes,
                        visible: true,
                        link: response.data.ficheiro,
                        fileList: [],
                        ficheiros: [],
                        texto: "",
                        visibleDrawerPesquisar: false,
                        visibleHTML: false
                    });
                } else {
                    setEstado({
                        documentoId: documentoId,
                        nome: response.data.nome.replace("." + response.data.nome.split(".").pop(), ""),
                        tipo: response.data.tipo,
                        tipo_partilha: response.data.tipo_partilha,
                        todos: response.data.todos,
                        participantes: response.data.participantes,
                        visible: true,
                        texto: response.data.ficheiro,
                        fileList: [],
                        ficheiros: [],
                        link: "",
                        visibleDrawerPesquisar: false,
                        visibleHTML: false
                    });
                }
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar o documento.");
                setEstado(prev => ({ ...prev, iconLoading: false }));
            });
    };

    const montarBotao = documento => {
        if (extensions.find(x => x === documento.extensao)) {
            return (
                <Link
                    to="#"
                    title="Visualizar"
                    className="botao-icon-detalhe"
                    onClick={() => {
                        setModalVisible(true);
                        setDocs([{ uri: documento.ficheiro }]);
                    }}
                >
                    <Icon type="eye" />
                </Link>
            );
        } else if (documento.link) {
            return (
                <a className="botao-icon-aceder" href={documento.ficheiro} target="_blank" rel="noopener noreferrer" title="Acessar">
                    <Icon type="login" />
                </a>
            );
        } else {
            return (
                <Link
                    className="botao-icon-aceder"
                    to="/utilizador-drive/player-ficheiro"
                    onClick={() => {
                        localStorage.setItem("codigo_documento", documento.id);
                    }}
                    title="Acessar"
                >
                    <Icon type="login" />
                </Link>
            );
        }
    };

    const carregar = useCallback(
        pesquisa => {
            setLoading(true);

            axios({
                method: "get",
                url: "/api/documentos/listar",
                params: {
                    ano: globalContext[`ano${match.params.code}`],
                    pesquisa: pesquisa
                }
            })
                .then(response => {
                    const documentos = response.data.map(documento => ({
                        key: documento.id,
                        data: documento.dt_alterado
                            ? moment(documento.dt_alterado).format("DD/MM/YYYY")
                            : moment(documento.dt_criado).format("DD/MM/YYYY"),
                        criado: documento.autor.nome_completo,
                        curso: documento.curso_pai == null ? documento.curso_nome : documento.curso_pai,
                        disciplina: documento.curso_nome,
                        documento: documento.nome,
                        opcoes: (
                            <div className="documentos-opcoes">
                                {montarBotao(documento)}
                                {documento.proprio && !documento.tipo && (
                                    <>
                                        <Link
                                            className="botao-icon-editar"
                                            to="#"
                                            onClick={() => {
                                                setVisible(true);
                                                setDocumentoId(documento.id);
                                                carregarDetalhe(documento.id);
                                                setDocumento(documento);
                                            }}
                                            title="Editar"
                                        >
                                            <Icon type="edit" />
                                        </Link>
                                        <Link className="botao-icon-excluir" to="#" onClick={() => excluir(documento.id)} title="Excluir">
                                            <Icon type="delete" />
                                        </Link>
                                    </>
                                )}
                            </div>
                        )
                    }));

                    setDocumentos(documentos);
                    setLoading(false);
                })
                .catch(error => {
                    if (error.response?.status === 401) {
                        setRedirectLink("/login");
                        setRedirect(true);
                    }
                    setLoading(false);
                });
        },
        [globalContext, match.params.code]
    );

    const atualizar = () => {
        carregar(search);
    };

    const onCloseDrawerHTML = () => {
        setEstado(prev => ({
            ...prev,
            texto: localStorage.getItem("editor_conteudo") ? localStorage.getItem("editor_conteudo") : "",
            visibleHTML: false
        }));

        localStorage.removeItem("editor_conteudo");
    };

    const anoCode = globalContext[`ano${match.params.code}`];

    useEffect(() => {
        if (activated) {
            carregar(search);
            setActivated(false); // só limpa depois de carregar
        } else if (anoCode) {
            carregar(search);
        }
    }, [activated, anoCode, search]);

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Table
                className="tabela-documentos tabela-documentos-professor"
                columns={cols}
                pagination={false}
                dataSource={documentos}
                loading={{
                    spinning: loading,
                    indicator: (
                        <div className="loading-data-table">
                            <div className="loading" />
                        </div>
                    )
                }}
            />

            <DrawerTabela estado={estado} setEstado={setEstado} carregar={carregar} setModalVisible={setModalVisible} setDocs={setDocs} />

            <DrawerHTML visible={estado.visibleHTML} recurso={estado.texto} onClose={onCloseDrawerHTML} />

            <DrawerPesquisar
                onClose={() =>
                    setEstado(prev => ({
                        ...prev,
                        visibleDrawerPesquisar: false
                    }))
                }
                participantes={estado.participantes}
                visibleDrawerPesquisar={estado.visibleDrawerPesquisar}
                selecionarParticipante={participante =>
                    setEstado(prev => ({
                        ...prev,
                        participantes: [...prev.participantes, participante]
                    }))
                }
            />

            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
        </>
    );
};

export default withRouter(Tabela);
